const PIXEL_ID = '1909818533027917'

declare global {
  interface Window {
    fbq?: any
    _fbq?: any
  }
}

let initialized = false

export const initMetaPixel = () => {
  if (typeof window === 'undefined' || initialized) return
  if (window.fbq) {
    initialized = true
    return
  }
  initialized = true

  // Meta Pixel base code (defensive version of the official snippet)
  const n: any = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  }
  window.fbq = n
  if (!window._fbq) window._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  // Load the pixel script — append to head/body instead of relying on existing <script> tag
  try {
    const script = document.createElement('script')
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'
    const target = document.head || document.body || document.documentElement
    if (target) {
      target.appendChild(script)
    }
  } catch (err) {
    console.warn('Meta Pixel script load failed:', err)
  }

  try {
    window.fbq('init', PIXEL_ID)
    window.fbq('track', 'PageView')
  } catch (err) {
    console.warn('Meta Pixel init failed:', err)
  }
}

export const trackPixel = (event: string, params?: Record<string, any>) => {
  if (typeof window === 'undefined' || !window.fbq) return
  try {
    if (params) {
      window.fbq('track', event, params)
    } else {
      window.fbq('track', event)
    }
  } catch (err) {
    console.warn('Meta Pixel track failed:', err)
  }
}
